import { countries } from '../data/data';

export const getCurrencyByCountryCode = (countryCode: string) => {
  const country = countries.find((c) => c.value === countryCode);
  return country ? country.currency : 'THB';
};
